import { render, staticRenderFns } from "./routing_input.vue?vue&type=template&id=38a3fb18&"
import script from "./routing_input.vue?vue&type=script&lang=js&"
export * from "./routing_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports